import { Role } from '@/shared/lib/types/admin';
import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import RequireRole from '@/shared/ui/components/RequireRole';
import type { RoutePathDefinition } from '../../types';

export const reportsSectionRoutes: RoutePathDefinition[] = [
  {
    path: 'my-dashboard',
    lazy: () => import('@/pages/tasks/ui/MyReportDashboard').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>My Dashboard</BreadcrumbLink> }
  },
  {
    path: 'dashboard',
    lazy: () => import('@/pages/reports/ui/ReportDashboard').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Dashboard</BreadcrumbLink> }
  },
  {
    path: 'encounters',
    lazy: () => import('@/pages/reports/ui/Encounters').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Encounters</BreadcrumbLink> }
  },
  {
    path: 'billing',
    lazy: () => import('@/pages/reports/ui/Billing').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Billing</BreadcrumbLink> }
  },
  {
    path: 'tasks',
    lazy: () => import('@/pages/reports/ui/Tasks').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Tasks</BreadcrumbLink> }
  },
  {
    path: 'health-plan',
    lazy: () => import('@/pages/reports/ui/HealthPlan').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Health Plan</BreadcrumbLink> }
  },
  {
    path: 'performance',
    lazy: () => import('@/pages/reports/ui/Performance').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Performance</BreadcrumbLink> }
  },
  {
    path: 'claims',
    // Every pharmacy's claims: Super Admin, and Admin read-only (z93r0b76qr).
    lazy: () =>
      import('@/pages/reports/ui/claims').then(m => ({
        Component: () => (
          <RequireRole roles={[Role.SUPER, Role.ADMIN]}>
            <m.default />
          </RequireRole>
        )
      })),
    handle: { crumb: () => <BreadcrumbLink>Claims</BreadcrumbLink> }
  },
  {
    path: 'rpm-providers',
    lazy: () => import('@/pages/reports/ui/RpmProviders').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Providers</BreadcrumbLink> }
  },
  {
    path: 'rpm-companies',
    lazy: () => import('@/pages/reports/ui/RpmCompanies').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Pharmacies</BreadcrumbLink> }
  },
  {
    path: 'rpm-chart-reviews',
    lazy: () => import('@/pages/reports/ui/RpmAllChartReviews').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Chart Reviews</BreadcrumbLink> }
  },
  {
    path: 'rpm-provider-signoffs',
    lazy: () => import('@/pages/reports/ui/RpmProviderSignoffs').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Provider SignOffs</BreadcrumbLink> }
  },
  {
    path: 'session-time',
    lazy: () => import('@/pages/reports/ui/UserSessionTime').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Session times</BreadcrumbLink> }
  },
  {
    path: 'rpm-metrics',
    lazy: () => import('@/pages/reports/ui/RpmMetrics').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>RPM Metrics</BreadcrumbLink> }
  },
  {
    path: 'ccm-reports',
    lazy: () => import('@/pages/reports/ui/CcmReports').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>CCM Reports</BreadcrumbLink> }
  },
  {
    path: 'payer-chart-requests',
    lazy: () => import('@/pages/reports/ui/PayerChartRequests').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Payer Chart Requests</BreadcrumbLink> }
  },
  {
    path: 'ai-search-feedback',
    lazy: () => import('@/pages/reports/ui/AiSearchFeedback').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>AI Search Feedback</BreadcrumbLink> }
  }
];
